import { CALL_API } from "../../middlewares/api";

export const GET_AFFILIATES_REQUEST = "GET_AFFILIATES_REQUEST";
export const GET_AFFILIATES_SUCCESS = "GET_AFFILIATES_SUCCESS";
export const GET_AFFILIATES_ERROR = "GET_AFFILIATES_ERROR";

export function get_affiliates() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/affiliates/list",
      method: "GET",
      authenticatedRequest: true,
      data: {},
      types: [
        GET_AFFILIATES_REQUEST,
        GET_AFFILIATES_SUCCESS,
        GET_AFFILIATES_ERROR,
      ],
    },
  };
}
